/* eslint-disable @typescript-eslint/ban-ts-comment */
import Logo from '@/components/atoms/Logo';
import Spinner from '@/components/atoms/Spinner';
import { useAuth } from '@/hooks/useAuth';
import routeNames from '@/routes/routeNames';
import { replaceRouteParam } from '@/utils/routes';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { SocketRequest } from '@/config/socket';
import Logger from '@/config/Logger';
import { AuthStore } from '@/state/AuthenticationStore';

export default function EmailVerifyPage() {
  const [loading, setLoading] = useState(false);
  const { logout } = useAuth();

  const handleResendVerificationEmail = async () => {
    setLoading(true);
    try {
      const response = await SocketRequest<null, { status: number }>(
        'send_verification_email',
        { data: null },
      );
      if (response.status === 200) {
        Logger.info('Verification email sent successfully');
      }
    } catch (error) {
      Logger.error('Failed to send verification email:', error);
    } finally {
      setLoading(false);
    }
  };
  const { code } = useParams();

  const verifyEmail = async (code: string) => {
    setLoading(true);
    try {
      const response = await SocketRequest<
        { code: string },
        { status: number }
      >('verify_email', { data: { code } });
      if (response.status === 200) {
        const workspaceId =
          AuthStore.user_workspace_info?.active_workspace?.workspace?._id;
        if (workspaceId) {
          window.location.href = replaceRouteParam(
            `${routeNames.dashboard.home}`,
            'workspaceId',
            workspaceId,
          );
        } else {
          Logger.error('Workspace ID not found');
        }
      }
    } catch (error) {
      Logger.error('Failed to verify email:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (code) {
      verifyEmail(code);
    }
  }, []);

  const signOut = () => {
    logout();
  };

  return (
    <div className='w-full h-screen  flex flex-col items-center bg-white '>
      {loading || code ? (
        <Spinner size={50} color={'#242263'} />
      ) : (
        <>
          <div className='w-full p-3 px-5 bg-white flex flex-row justify-between'>
            <div className='flex flex-row cursor-pointer items-center'>
              <Link
                className='flex items-center'
                to={routeNames.authentication.login}
              >
                <Logo size='md' />
                <p className='ml-2 text-lg font-semibold noselect'>Sparkhub</p>
              </Link>
            </div>
            <p
              className='underline cursor-pointer text-primary-light'
              onClick={signOut}
            >
              Sign out
            </p>
          </div>
          <div className='flex flex-col w-full h-full items-center lg:pl-96 lg:pr-96 pl-5 pr-5 bg-white'>
            <h2 className='text-[38px] font-bold mt-20'>You’re almost there</h2>
            <p className='mt-10 text-[15px] text-center'>
              Thanks for signing up! You should see a verification link in your
              email (it might be in your spam folder). Verify your email to
              start with Sparkhub today.
            </p>
            <p
              onClick={handleResendVerificationEmail}
              className='mt-10 text-[15px] text-center border-b-2 border-gray-500 border-dotted cursor-pointer'
            >
              Click here if you didn’t get an email from Sparkhub.
            </p>
            <img
              src='https://static.intercomassets.com/ember/assets/images/signup-teams/SMB_Hero@2x-c4a1deb14efa7a3074b3af16633ae87a.png'
              className='w-[300px] h-[300px] mt-10'
            />
          </div>
        </>
      )}
    </div>
  );
}
